import { t } from '@avalara/bat-apps-shared/i18n';
import { SCol, SRow } from '@avalara/skylab-sdk/react';

import Banner from '../../styled/components/single-column-banner';

const ThankYouBanner = () => (
  <Banner className='flex-dir-col flex align-items-center pad pad-top-lg pad-bottom-lg' role='complementary'>
    <SRow className='align-items-center'>
      <SCol span='12' center='' className='pad-bottom-none'>
        <p className='fourth-line text-uppercase'>{t('client.general.avalara-professional-services')}</p>
      </SCol>
    </SRow>
    <SRow className='align-items-center'>
      <SCol span='12' center='' className='pad-bottom-none'>
        <p className='single-line' data-ref='risk-assessment.thankyou-header'>
          {t('client.general.thanks-for-buying-a-sales-tax-risk-assessment')}
        </p>
      </SCol>
    </SRow>
  </Banner>
);
export default ThankYouBanner;
